export { default } from "./AgeGate";
